"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.migrateXlsx2Csv = void 0;
const uuid_1 = require("uuid");
const generateXlsx2Csv2Config_1 = require("./generateXlsx2Csv2Config");
const uinode_1 = require("./operations/sanitize/uinode");
const Stack = __importStar(require("./operations/stack/types"));
const uinode_2 = require("./operations/xlsx2csv/uinode");
const Xlsx2Csv2 = __importStar(require("./operations/xlsx2csv2/types"));
const registry_1 = require("./registry");
const utils_1 = require("./utils");
const getOnly = (nodes) => (nodes.length === 1 ? nodes[0] : null);
const nodeId = (node) => node.metadata.tapeBuilderNodeId;
const migrateOne = (graph, xlsx2csvNode, getHeaders) => {
    const xlsx2csvId = nodeId(xlsx2csvNode);
    const rawNode = getOnly((0, utils_1.getSourceNodes)({ graph, node: xlsx2csvNode }));
    if (!rawNode) {
        return { ok: false, reason: 'expected exactly one input' };
    }
    if (!(0, registry_1.isTapeBuilderFileNode)(rawNode)) {
        return {
            ok: false,
            reason: `input must be a tape, got [${rawNode.metadata.tapeBuilderNodeType}]`,
        };
    }
    const tapeA = getOnly((0, utils_1.getTargetNodes)({ graph, node: xlsx2csvNode }));
    if (!tapeA) {
        return { ok: false, reason: 'expected exactly one output tape' };
    }
    // tape A changes from raw CSV to sanitized output, so nothing else may read it.
    const sanitizeNode = getOnly((0, utils_1.getTargetNodes)({ graph, node: tapeA }));
    if (!sanitizeNode || !uinode_1.operation_sanitize.isNode(sanitizeNode)) {
        const next = (0, utils_1.getTargetNodes)({ graph, node: tapeA }).map((n) => n.metadata.tapeBuilderNodeType);
        return {
            ok: false,
            reason: `output tape must feed only a sanitize, feeds [${next.join(', ')}]`,
        };
    }
    const tapeB = getOnly((0, utils_1.getTargetNodes)({ graph, node: sanitizeNode }));
    if (!tapeB) {
        return { ok: false, reason: 'sanitize must have exactly one output tape' };
    }
    const xlsx2csvConfig = xlsx2csvNode.configuration;
    const headers = getHeaders &&
        xlsx2csvConfig.mode === 'convertRange' &&
        xlsx2csvConfig.headerRange
        ? getHeaders({
            rawSlug: (0, registry_1.getArtifactSlugForTapeNode)(rawNode),
            sheetName: xlsx2csvConfig.sheetName,
            headerRange: xlsx2csvConfig.headerRange,
        })
        : null;
    const { config, errors } = (0, generateXlsx2Csv2Config_1.generateXlsx2Csv2Config)({
        sanitizeNode,
        xlsx2csvNode,
        headers,
    });
    if (!config) {
        return { ok: false, reason: errors.join('; ') };
    }
    const xlsx2csv2Node = {
        metadata: {
            tapeBuilderNodeId: (0, uuid_1.v4)(),
            tapeBuilderNodeType: Xlsx2Csv2.nodeType,
        },
        configuration: config,
    };
    const stackNode = {
        metadata: {
            tapeBuilderNodeId: (0, uuid_1.v4)(),
            tapeBuilderNodeType: Stack.nodeType,
        },
        configuration: { operation: 'stack', ensureUniqueFields: [] },
    };
    const removedIds = new Set([xlsx2csvId, nodeId(sanitizeNode)]);
    const edges = [
        ...graph.edges.filter((e) => !removedIds.has(e.source) && !removedIds.has(e.target)),
        { source: nodeId(rawNode), target: nodeId(xlsx2csv2Node) },
        { source: nodeId(xlsx2csv2Node), target: nodeId(tapeA) },
        { source: nodeId(tapeA), target: nodeId(stackNode) },
        { source: nodeId(stackNode), target: nodeId(tapeB) },
    ];
    const nodes = [
        ...graph.nodes.filter((n) => !removedIds.has(nodeId(n))),
        xlsx2csv2Node,
        stackNode,
    ];
    return {
        ok: true,
        graph: { nodes, edges },
        tapeB: (0, registry_1.getArtifactSlugForTapeNode)(tapeB),
        warnings: errors,
    };
};
const migrateXlsx2Csv = (graph, { getHeaders }) => {
    const result = {
        graph,
        migrated: [],
        skipped: [],
        warnings: [],
    };
    graph.nodes.filter(uinode_2.operation_xlsx2Csv.isNode).forEach((xlsx2csvNode) => {
        const outcome = migrateOne(result.graph, xlsx2csvNode, getHeaders);
        if (outcome.ok) {
            result.graph = outcome.graph;
            result.migrated.push(outcome.tapeB);
            result.warnings.push(...outcome.warnings.map((w) => `[${outcome.tapeB}] ${w}`));
        }
        else {
            result.skipped.push({
                xlsx2csvNodeId: nodeId(xlsx2csvNode),
                reason: outcome.reason,
            });
        }
    });
    return result;
};
exports.migrateXlsx2Csv = migrateXlsx2Csv;
//# sourceMappingURL=migrateXlsx2Csv.js.map